import { $api } from '@/api/typedClient'
import { useTenantStore } from '@/stores/tenantStore'

export function useFormSchemas() {
  const { selectedTenant } = useTenantStore()

  return $api.useQuery(
    'post',
    '/crossroads/entity/form_schemas',
    {},
    {
      enabled: !!selectedTenant?.name,
      staleTime: 5 * 60 * 1000,
    },
  )
}
